import { render, staticRenderFns } from "./ConferenceEnded.vue?vue&type=template&id=5d4c10b4"
import script from "./ConferenceEnded.vue?vue&type=script&lang=js"
export * from "./ConferenceEnded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d4c10b4')) {
      api.createRecord('5d4c10b4', component.options)
    } else {
      api.reload('5d4c10b4', component.options)
    }
    module.hot.accept("./ConferenceEnded.vue?vue&type=template&id=5d4c10b4", function () {
      api.rerender('5d4c10b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ConferenceEnded.vue"
export default component.exports